export const footerLinksForEmptyLayout = [

    {
        title: 'Contact us',
        href: '/contact',
        target: ''
    },
    {
        title: 'Register',
        href: '/registration/outlet',
        target: ''
    },
    {
        title: 'Login',
        href: '/login',
        target: ''
    }
];

export const footerLinksForMainLayout = [
    {
        title: 'Terms & Conditions',
        href: '/content-pages/terms-conditions',
        target: '_blank'
    },
    {
        title: 'Privacy Policy',
        href: '/content-pages/privacy-policy',
        target: '_blank'
    },
    {
        title: "FAQ's",
        href: '/about-ignite',
        target: ''
    },
    {
        title: "Logout",
        href: '/logout',
        target: ''
    }
];



// WEBPACK FOOTER //
// ./src/data/footerLinks.js